import React from 'react';
import { AttributeRulesType, AttributeRules } from '../../../_lib/components/AttributeRules/AttributeRules';
import { AttributeRule } from '../../../types/api/AttributeGroups';
import { useTranslation } from 'react-i18next';

export type AttributeGroupInfoRules = AttributeRulesType;

export function AttributeGroupInfoRules({ ruleCombination, rules }: AttributeRulesType) {
  const { t } = useTranslation('PersonAttributes');
  const transformRules = (attributeRules: AttributeRule[]) =>
    attributeRules.map(rule => ({
      ...rule,
      attributeName: t(`${rule.attributeName}`),
    }));

  return (
    <div className="attribute-group-info">
      <AttributeRules rules={transformRules(rules)} ruleCombination={ruleCombination} />
    </div>
  );
}
